module.exports = __webpack_public_path__ + "img/google-logo-white.7b4087fd.svg";